<template>
  <div>
    <button
      v-if="
        shirt.type !== 'lady' ||
        (shirt.type === 'lady' && shirt.lady_size_loaded)
      "
      class="btn btn-sm btn-ps mb-2"
      :class="
        shirt.type === 'lady' && !shirt.pattern_url
          ? 'btn-warning'
          : 'btn-primary'
      "
      @click="printProductionSheet()"
    >
      {{
        doesShirtOrderStatusNeedChangingDueToProductionSheetPrinting
          ? "New"
          : ""
      }}
      Production Sheet
    </button>

    <button
      v-else-if="shirt.type === 'lady' && !shirt.lady_size_loaded"
      class="btn btn-sm btn-secondary btn-ps mb-2"
      disabled
    >
      New Production Sheet
    </button>

    <span
      v-if="
        showPatternPrintingButtonOnTheTableList &&
        (shirt.type !== 'lady' ||
          (shirt.type == 'lady' && shirt.pattern_url !== null))
      "
    >
      <button
        class="btn btn-sm btn-pattern mb-2"
        :class="
          !isPrintPatternEnabled ? 'btn-grey' :
          doesShirtOrderStatusNeedChangingDueToPatternPrinting
            ? 'btn-warning'
            : 'btn-success'
        "
        :disabled="!isPrintPatternEnabled"
        @click="printPattern()"
      >
        {{ doesShirtOrderStatusNeedChangingDueToPatternPrinting ? "New" : "" }}
        Pattern
      </button>
    </span>
  </div>
</template>

<script>
import {
  doesShirtOrderStatusNeedChangingDueToPatternPrinting,
  doesShirtOrderStatusNeedChangingDueToProductionSheetPrinting,
} from "../tools/ShirtOrderStatus";
export default {
  props: {
    shirt: {
      type: [Object],
      default: null,
    },
    showPatternPrintingButtonOnTheTableList: {
      default: true,
      type: Boolean,
    },
  },
  computed: {
    doesShirtOrderStatusNeedChangingDueToProductionSheetPrinting() {
      return doesShirtOrderStatusNeedChangingDueToProductionSheetPrinting(
        shirtOrderStatus,
        this.shirt.production_docs_ready,
        this.shirt.shirt_order_status.id
      );
    },
    doesShirtOrderStatusNeedChangingDueToPatternPrinting() {
      return doesShirtOrderStatusNeedChangingDueToPatternPrinting(
        shirtOrderStatus,
        this.shirt.production_docs_ready,
        this.shirt.shirt_order_status.id
      );
    },
    /**
     * Print Pattern is enabled only after the production sheet is printed
     *
     * The sorter for COLLECTOR_PRINTED is 2,
     * So when current status sorter is 2 or greater than 2
     * Which mean production sheet is already printed
     */
    isPrintPatternEnabled() {
      return this.shirt.shirt_order_status.sorter >= 2
    }
  },
  methods: {
    async printProductionSheet() {
      let data = this.shirt;
      let changeShirtOrderStatus = this
        .doesShirtOrderStatusNeedChangingDueToProductionSheetPrinting;
      let params = [{ id: data.id, changeShirtOrderStatus }];
      this.$emit("click", params);
    },

    async printPattern() {
      let data = this.shirt;
      let changeShirtOrderStatus = this
        .doesShirtOrderStatusNeedChangingDueToPatternPrinting;
      let shirtOrders = [{ id: data.id, changeShirtOrderStatus }];
      let url = "/pattern/" + JSON.stringify(shirtOrders);
      await ezy.openPDFInNewWindow(url);
      data.shirt_order_status.id = shirtOrderStatus.PATTERN_PRINTED;
    },
  },
};
</script>

<style scoped>
</style>
